import { Box, Grid, IconButton, useTheme } from "@mui/material";
import React, { ReactNode } from "react";
import {CloseOutlined, Add} from '@mui/icons-material';

interface Props {
    columns: Array<ReactNode>,
    addColumn: () => void,
    removeColumn: (index: number) => void
}

const ExtendableRow : React.FC<Props> = ({columns, addColumn, removeColumn}) => {
    const theme = useTheme();

    return <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'stretch'}}>
        <Box sx={{overflow: 'auto', width: '90%'}}>
            <Grid container sx={{minWidth: `${(columns?.length??1) * 300}px`}}>
            {columns.map((c, i) => <Grid item xs={columns?.length > 0 ? (Math.floor(12/columns?.length)) : 0} sx={{minWidth: '300px'}}>
                <Box sx={{textAlign: "right"}}>
                    <IconButton onClick={() => {
                        removeColumn(i);
                        }}>
                        <CloseOutlined />
                    </IconButton>
                </Box>
                {c}
                </Grid>)}
            </Grid>
        </Box>
        <Box sx={{textAlign: 'center', width: '10%', minWidth: '24px'}}>
            <IconButton sx={{background: theme?.palette?.primary?.light, position: 'sticky', marginTop: '1.5em'}} onClick={addColumn}>
                <Add />
            </IconButton>
        </Box>
    </Box>
}

export default ExtendableRow;